var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29 0H4C1.79086 0 0 1.79086 0 4V29C0 31.2091 1.79086 33 4 33H29C31.2091 33 33 31.2091 33 29V4C33 1.79086 31.2091 0 29 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 23.4167C21.4998 24.146 21.2101 24.8455 20.6944 25.3612C20.1787 25.8769 19.4792 26.1667 18.7498 26.1667H12.3332C11.6038 26.1667 10.9044 25.8769 10.3886 25.3612C9.8729 24.8455 9.58317 24.146 9.58317 23.4167V12.4167H8.6665V9.66667H12.7915L13.7082 8.75H17.3748L18.2915 9.66667H22.4165V12.4167H21.4998V23.4167ZM10.4998 12.4167V23.4167C10.4998 23.9029 10.693 24.3692 11.0368 24.713C11.3806 25.0568 11.8469 25.25 12.3332 25.25H18.7498C19.2361 25.25 19.7024 25.0568 20.0462 24.713C20.39 24.3692 20.5832 23.9029 20.5832 23.4167V12.4167H10.4998ZM21.4998 11.5V10.5833H17.8332L16.9165 9.66667H14.1665L13.2498 10.5833H9.58317V11.5H21.4998ZM12.3332 14.25H13.2498V23.4167H12.3332V14.25ZM17.8332 14.25H18.7498V23.4167H17.8332V14.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDeleteIcon);
export default __webpack_public_path__ + "static/media/whiteDeleteIcon.d6990bfec8371b1cb4cadda504fb28ef.svg";
export { ForwardRef as ReactComponent };